import { AssignmentQuiz, DashboardStream, SubjectNotice } from 'components/common/dashboard';
import BreadCrumb from 'components/shared/BreadCrumb';
import { useGetCalendarApi, useGetCommonApi, useGetQuery, useGetTeacherQuery } from 'hooks';

import { StudySentence } from 'components/common/dashboard/StudySentence';
import { SubjectNoticePopup } from 'components/popup';
import { DashBoardNews } from 'components/shared/dashboard/DashBoardNews';
import { useGetRequiredApi } from 'hooks/useGetRequiredApi';
import { getDataQuery } from 'api';
import { useRecoilState, useResetRecoilState } from 'recoil';
import { subjectNoticePopupState } from 'recoil/dashboard/subjectNoticePopupState';
import { Link, useNavigate } from 'react-router-dom';
import { Form, Tab, Tabs } from 'react-bootstrap';
import useSsoRouting from 'hooks/common/useSsoRouting';
import { getLectureQuery } from 'api/getLectureQuery';
import { useEffect, useState } from 'react';
import { ScheduleCalendar } from 'components/calendar';
import { useCalendarIndex } from 'recoil/caleandar/calendarIndex';
import { CardHeader } from 'components/common';
import { subjectOptionDataState } from 'recoil/subject/subjectOptionDataState';
import { AdminSubjectNotice } from 'components/common/dashboard/AdminSubjectNotice';
import { adminSubjectState } from 'recoil/subject/adminSubjectState';
import { sisCourseState } from 'recoil/subject/sisCourseState';
import { teacherInfoState } from 'recoil/subject/teacherInfoState';

export function AdminDashBoard() {
  const navigate = useNavigate();
  const [subjectPopupState, setSubjectPopupState] = useRecoilState(subjectNoticePopupState);
  const [key, setKey] = useState("subjectNotice");
  const [calendarIndex, setCalendarIndex] = useRecoilState(useCalendarIndex);
  const [subjectState, setSubjectState] = useRecoilState(subjectOptionDataState);
  const [optionData, setOptionData] = useState([]);
  const [subOptionData, setSubOptionData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [adminSelectState, setAdminSelectState] = useRecoilState(adminSubjectState);
  const [sisCourseIdState, setSisCourseIdState] = useRecoilState(sisCourseState);
  const [selectTeacherInfo, setSelectTeacherInfo] = useRecoilState(teacherInfoState)
  const resetSubjectState = useResetRecoilState(subjectOptionDataState);
  const resetTeacherInfo = useResetRecoilState(teacherInfoState);
  const resetSisCourse = useResetRecoilState(sisCourseState);
  const resetAdminSubject = useResetRecoilState(adminSubjectState);

  const [activeKey, setActiveKey] = useState('academicSchedule'); // 기본 활성 탭 설정

  useEffect(() => {
    resetSubjectState();
    resetTeacherInfo();
    resetSisCourse();
    resetAdminSubject();
  }, []);

  const handleTabSelect = (k) => {
    setActiveKey(k); // 탭 변경 시 상태 업데이트
  };

  const {
    // 학기정보
    semesterData,
    semesterIsLoading,
    semesterIsError,

    semestersData,
    semestersIsLoading,
    semestersIsError,
  } = useGetCommonApi();

  const {
    // 관리자 - 전체 학과 리스트 조회
    adminSelectBoxQueryData,

    // 관리자 - 해당 학과의 과목 리스트
    adminSubSelectBoxQueryData,

    // 교수자 / 관리자 - 해당 학과의 담당 교수, 지도 교수 조회
    adminTeacherInfoSelectBoxQueryData,
  } = useGetRequiredApi(adminSelectState.lectureId, subjectState.openYy, subjectState.openTmGbn, sisCourseIdState.scCd, sisCourseIdState.openDeptCd);

  const {
    // 교수자 / 관리자 - [학습현황] 등록되어 있는 게시중인 과목 리스트 정보 API
    // subject 상위 select-box list
    teacherSelectBoxQueryData,
    teacherSelectBoxQueryIsLoading,
    teacherSelectBoxQueryIsError,
  } = useGetRequiredApi();

  const {
    // 학사일정
    calendarAcademicData,
    calendarAcademicIsLoading,
    calendarAcademicIsError,
    // 유저일정
    calendarUserData,
    calendarUserIsLoading,
    calendarUserIsError,
  } = useGetCalendarApi();

  const { assignmentData, assignmentIsLoading } = useGetTeacherQuery();
  const { teacherStudentProgressData } = useGetTeacherQuery();

  const {
    // 활동 스트림
    activitySteamData,
    activitySteamIsLoading,
    activitySteamIsError,
  } = useGetQuery();

  useEffect(() => {
    if (adminSubSelectBoxQueryData?.length > 0) {
      const firstItem = adminSubSelectBoxQueryData[0].account_course_dto.sis_course_id;
      const parts = firstItem.split('-');
  
      const semesterYear = `${parts[0]}-${parts[1]}`;
      
      const sisCourseData = {
        openYy: parts[0] || null,
        openTmGbn: parts[1] || null,
        scCd: parts[2] || null,
        openDeptCd: semesterYear === '2024-10' ? parts[3] || null : parts.at(-1) || null,
      };

      setSisCourseIdState(sisCourseData);
    }
  }, [adminSubSelectBoxQueryData]);

  useEffect(() => {
    const termId = subjectState.termId;
    if (!termId || !semestersData?.data) return;
    const selected = semestersData.data.find(item => item.id === Number(termId));
    if (selected?.sis_term_id) {
      const sisTermId = selected.sis_term_id;
      setSisCourseIdState({
        openYy: sisTermId.substring(0, 4) || null,
        openTmGbn: sisTermId.substring(4) || null,
        scCd: null,
        openDeptCd: null,
      });
    }
  }, [subjectState.termId, semesterData, semestersData]);

  
  // 학과 이벤트 핸들러
  const handleSelectIdBox = (e) => {
    if (!e.target.value) return;
    setAdminSelectState({ ...adminSelectState, lectureId: e.target.value, lectureTitle: e.target.options[e.target.selectedIndex]?.text || '' });
    setSubjectState({ ...subjectState, courseId: null });
    setSelectTeacherInfo({ managerNumber: null, managerName: null, advisorNumber: null, advisorName: null, sisCourseId: [] });
  };

  // 학기 이벤트 핸들러
  const handleSelectTermBox = (e) => {
    if (!e.target.value) return;
    const selected = semestersData?.data?.find(item => item.id === Number(e.target.value));
    const sisTermId = selected?.sis_term_id || '';
    const openYy = sisTermId.length >= 4 ? parseInt(sisTermId.substring(0, 4)) : null;
    const openTmGbn = sisTermId.length > 4 ? parseInt(sisTermId.substring(4)) : null;
    setSubjectState({ courseId: null, termId: e.target.value, termName: selected?.name || '', openYy, openTmGbn });
    setAdminSelectState({ ...adminSelectState, lectureId: '', lectureTitle: '' });
    setSelectTeacherInfo({ managerNumber: null, managerName: null, advisorNumber: null, advisorName: null, sisCourseId: [] });
    if (sisTermId) {
      setSisCourseIdState({
        openYy: sisTermId.substring(0, 4) || null,
        openTmGbn: sisTermId.substring(4) || null,
        scCd: null,
        openDeptCd: null,
      });
    }
  }

  // 대표교수 이벤트 핸들러
  const handleSelectManegerTeacherBox = async (e) => {
    setSelectTeacherInfo([]);
    const selectedValue = e.target.value;
    const selectedName = e.target.options[e.target.selectedIndex].text;

    if (!selectedValue || !selectedName) return;

    const selectedProfessor = adminTeacherInfoSelectBoxQueryData?.flatMap(item => item.mainTeachers)
      .find(teacher => teacher.teacherNumber === selectedValue);

    if (!selectedProfessor) return;

    const selectedSisCourseId = selectedProfessor.courseTeacherInfo[0].sisCourseId;
    const matchedCourse = adminSubSelectBoxQueryData?.find(
      c => c.account_course_dto.sis_course_id === selectedSisCourseId
    );

    if (!matchedCourse) return;

    const courseId = matchedCourse.account_course_dto.course_id;
    const parts = selectedSisCourseId.split('-');
    const openYy = parts[0];
    const openTmGbn = parts[1];

    const res = await getDataQuery(
      `/teach/info/advisors?courseId=${courseId}&openYy=${openYy}&openTmGbn=${openTmGbn}&sisCourseId=${selectedSisCourseId}`
    );

    setSelectTeacherInfo(prev => ({
      ...prev,
      managerNumber: selectedValue,
      managerName: selectedName,
      filteredAdvisors: res?.data || [],
    }));
  };
  
  // 지도교수 이벤트 핸들러
  const handleSelectAdvisorBox = (e) => {
    const selectedTeacherNumber = e.target.value;
    const selectedAdvisor = selectTeacherInfo.filteredAdvisors?.find(
      item => item.teacherNumber === selectedTeacherNumber
    );
  
    if (!selectedAdvisor) return;
  
    // 선택한 지도교수의 sisCourseId 목록 추출
    const advisorSisCourseIds = selectedAdvisor.courseTeacherInfo.map(course => course.sisCourseId);
  
    setSelectTeacherInfo(prev => ({
      ...prev,
      advisorNumber: selectedAdvisor.teacherNumber,
      advisorName: selectedAdvisor.teacherName,
      sisCourseId: advisorSisCourseIds,
    }));
  };
  

  const { ssoRouting } = useSsoRouting();
  // 온라인 강의실
  const handleGoingLecture = async (url) => {
    ssoRouting(url);
    const { data: getCanvasUrl } = await getLectureQuery('');
    
    if (getCanvasUrl?.errorCode) return;
    window.location.replace(getCanvasUrl);
  };

  const handleAttendancesAndGrades = (type, course) => {
    setSubjectState({...subjectState, courseId: course.account_course_dto.course_id, courseName: course.account_course_dto.course_name });
    if (type === 'attendance') {
      navigate('/attendance')
    } else if (type === 'grade') {
      navigate('/grade')
    }
  };

  const handleSelect = (k) => {
    setKey(k);
  };

  const switchCalendar = () => {
    setCalendarIndex(!calendarIndex);
  };

  return (
    <>
      <main id='main' className='main'>
        <div className='d-flex justify-content-start align-items-center'>
          <BreadCrumb home={'/'} sublink={'/'} title={'My Class'} subTitle={'홈'} />
          <div className="d-flex justify-content-start align-items-center ml-20"
            style={{ gap: "2rem" }}>
              <div className='d-flex align-items-center'>
                <Form.Select
                  id="subjectTerm"
                  name="subjectTerm"
                  onChange={handleSelectTermBox}
                  value={subjectState.termId || ''}
                >
                  <option value="">학기 선택</option>
                  {semestersData?.data?.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </Form.Select>
              </div>
              <div className='d-flex align-items-center'>
                <Form.Select
                  id="subjectDepartment"
                  name="subjectDepartment"
                  onChange={handleSelectIdBox}
                  style={{ width: "200px" }}
                  value={adminSelectState?.lectureId}
                  disabled={!subjectState.termId}
                >
                  <option value="">학과 선택</option>
                  {adminSelectBoxQueryData?.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </Form.Select>
              </div>
              {/* 대표교수 선택 - 2025년도 이상일 때만 표시 */}
              {parseInt(subjectState.openYy) >= 2025 && (
              <div className='d-flex align-items-center'>
                <Form.Select
                  aria-label='Default select example'
                  id='subjectWeek'
                  name='subjectWeek'
                  onChange={handleSelectManegerTeacherBox}
                  style={{ width: "200px" }}
                >
                  <option value=''>대표교수 선택</option>
                  {adminTeacherInfoSelectBoxQueryData?.flatMap((item) =>
                    item.mainTeachers.map((teacher) => (
                      <option key={teacher.teacherNumber} value={teacher.teacherNumber}>
                        {teacher.teacherName}
                      </option>
                    ))
                  )}
                </Form.Select>
              </div>
              )}
              {/* 지도교수 선택 - 2025년도 이상일 때만 표시 */}
              {parseInt(subjectState.openYy) >= 2025 && (
              <div className='d-flex align-items-center'>
              <Form.Select
                aria-label='지도교수 선택'
                id='advisorProfessorSelect'
                name='advisorProfessor'
                onChange={handleSelectAdvisorBox}
                style={{ width: "200px" }}
                value={selectTeacherInfo.advisorNumber || ""}
              >
                <option value=''>지도교수 선택</option>
                {selectTeacherInfo.filteredAdvisors?.map(teacher => (
                  <option key={teacher.teacherNumber} value={teacher.teacherNumber}>
                    {teacher.teacherName} - {teacher.courseTeacherInfo?.map(course => {
                      const parts = course.sisCourseId.split('-');
                      return parts[3];
                    }).join(', ')}
                  </option>
                ))}
              </Form.Select>
              </div>
              )}
          </div>
        </div>
        <section className='section dashboard'>
          <div className='row'>
            <div className='col-lg-8'>
              <div className='row'>
                <div className="cards-container">
                {adminSubSelectBoxQueryData
                  ?.filter(course => {
                    const courseYear = course.account_course_dto.sis_course_id.split('-')[0]; // 연도(앞 4자리) 추출

                    // 2024년이면 selectTeacherInfo 체크 없이 전체 데이터 반환
                    if (courseYear === "2024") {
                      return true;
                    }

                    // 2024년이 아니면 selectTeacherInfo가 존재하고, sisCourseId가 일치하는 경우만 반환
                    return selectTeacherInfo.managerNumber && selectTeacherInfo.advisorNumber &&
                      selectTeacherInfo.sisCourseId.some(sisCourseId => sisCourseId === course.account_course_dto.sis_course_id);
                  })
                  .map((course, idx) => (
                    <div key={course.account_course_dto.course_id} className="horizontal-course-card">
                      <div className={`d-flex justify-content-between card-header ch-bg${idx + 1}`}>
                        <h3 className="card-title">{course.account_course_dto.course_name}</h3>
                        {parseInt(subjectState.openYy) < 2025 ? ("")
                        : (
                        <h3 className="card-title">대표교수: {selectTeacherInfo.managerName} / 지도교수: {selectTeacherInfo.advisorName}</h3>
                        )}
                      </div>
                      <div className="card-tab">
                        <div className="card-tab-content mr-5" onClick={() => handleGoingLecture(`/courses/${course.account_course_dto.course_id}`)}>
                          <img
                            src="/assets/img/icon/home_icon.png"
                            alt="Announcements Icon"
                            className="card-icon-img"
                          />
                          <div>홈</div>
                        </div>
                        <div className="card-tab-content mr-5" onClick={() => handleGoingLecture(`/courses/${course.account_course_dto.course_id}/announcements`)}>
                          <img
                            src="/assets/img/icon/announcements_icon.png"
                            alt="Announcements Icon"
                            className="card-icon-img"
                          />
                          <div>공지사항</div>
                        </div>
                        <div className="card-tab-content mr-5" onClick={() => handleGoingLecture(`/courses/${course.account_course_dto.course_id}/assignments`)}>
                          <img
                            src="/assets/img/icon/assignments_icon.png"
                            alt="Assignments Icon"
                            className="card-icon-img"
                          />
                          <div>과제</div>
                        </div>
                        <div className="card-tab-content mr-5" onClick={() => handleAttendancesAndGrades("attendance", course)}>
                          <img
                            src="/assets/img/icon/attendances_icon.png"
                            alt="Grades Icon"
                            className="card-icon-img"
                          />
                          <div>출석</div>
                        </div>
                        <div className="card-tab-content mr-5" onClick={() => handleAttendancesAndGrades("grade", course)}>
                          <img
                            src="/assets/img/icon/grades_icon.png"
                            alt="Grades Icon"
                            className="card-icon-img"
                          />
                          <div>성적</div>
                        </div>
                        <div className="card-tab-content mr-5"onClick={() => handleGoingLecture(`/courses/${course.account_course_dto.course_id}/users`)}>
                          <img
                            src="/assets/img/icon/user_group_icon.png"
                            alt="Announcements Icon"
                            className="card-icon-img"
                          />
                          <div>사용자 및 그룹</div>
                        </div>
                        <div className="card-tab-content mr-5" onClick={() => handleGoingLecture(`/courses/${course.account_course_dto.course_id}/files`)}>
                          <img
                            src="/assets/img/icon/files_icon.png"
                            alt="Files Icon"
                            className="card-icon-img"
                          />
                          <div>파일</div>
                        </div>
                        <div className="card-tab-content" onClick={() => handleGoingLecture(`/courses/${course.account_course_dto.course_id}/assignments/syllabus`)}>
                          <img
                            src="/assets/img/icon/lecture_plan_icon.png"
                            alt="Announcements Icon"
                            className="card-icon-img"
                          />
                          <div>강의계획서</div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className='col-lg-4'>
              <div className="card p-20">
                <Tabs
                  id="schedule-tabs"
                  activeKey={activeKey}
                  onSelect={handleTabSelect}
                  className="custom-tabs"
                >
                  {/* 학사일정 탭 */}
                  <Tab eventKey="academicSchedule" title="학사일정">
                    <ScheduleCalendar
                      data={
                        calendarIndex && calendarAcademicData
                          ? calendarAcademicData
                          : []
                      }
                    />
                  </Tab>
                </Tabs>
              </div>
              <Tabs
                id="controlled-tab-example"
                activeKey={key}
                onSelect={handleSelect}
                className="custom-tabs"
              >
                <Tab eventKey="subjectNotice" title="과목 공지사항">
                  <AdminSubjectNotice
                    data={teacherSelectBoxQueryData?.map((el) => ({
                      ...el,
                      name: el.course_name,
                      course_id: el.course_id,
                    }))}
                    cardTitle={semesterData?.data?.name}
                  />
                </Tab>
                <Tab eventKey="ctlNotice" title="공지사항">
                  <DashBoardNews />
                </Tab>
              </Tabs>
            </div>
          </div>
        </section>
      </main>
      {subjectPopupState.visible && <SubjectNoticePopup />}
    </>
  );
}
